import axios from "axios";

//  function to handle the sign-in request
export const signIn = async (userData) => {
  try {
    const response = await axios.post(
      `https://v4.backend.hyperthings.in/api/v1/user-roles/sign-in`,
      userData
    );
    console.log("Sign-in Response:", response.data);
    return response.data; // Return response data so it's accessible in handleSubmit
  } catch (error) {
    // If the error response has a structured message (code, message), extract it
    const errorMessage = error.response?.data || { code: 500, message: 'Unknown error occurred' };
    
    // Log the error and include the details
    console.error("Sign-in Error:", errorMessage);
    
    // Throw the error to handle it in handleSubmit
    throw new Error(errorMessage.message || 'Error during sign-in');
  }
};


//  function to handle the send-otp request
export const sendOtp = async (userData) => {
  try {
    const response = await axios.post(
      `https://v4.backend.hyperthings.in/api/v1/user-roles/resendOtp`,
      userData
    );
    console.log("Sign-in Response:", response.data);
    return response.data; // Return response data so it's accessible in handleSubmit
  } catch (error) {
    const errorMessage = error.response?.data || { code: 500, message: 'Unknown error occurred' };
    console.error("Sign-in Error:", errorMessage);
    throw new Error(errorMessage.message || 'Error during send-opt');
  }
};

//  function to handle the sign-in request
export const verifyOtp = async (otpData) => {
  try {
    const response = await axios.post(
      `https://v4.backend.hyperthings.in/api/v1/user-roles/verifyOtp`,
      otpData
    );
    console.log("Sign-in Response:", response.data);
    return response.data; // Return response data so it's accessible in handleSubmit
  } catch (error) {
    const errorMessage = error.response?.data || { code: 500, message: 'Unknown error occurred' };
    console.error("Sign-in Error:", errorMessage);
    throw new Error(errorMessage.message || 'Error during verify-opt');
  }
};

//  function to handle the sign-in request
export const ForgotPasswordUpdate = async (passwordData) => {
  try {
    const response = await axios.post(
      `https://v4.backend.hyperthings.in/api/v1/user-roles/forgot-password`,
      passwordData
    );
    console.log("Sign-in Response:", response.data);
    return response.data; // Return response data so it's accessible in handleSubmit
  } catch (error) {
    const errorMessage = error.response?.data || { code: 500, message: 'Unknown error occurred' };
    console.error("Sign-in Error:", errorMessage);
    throw new Error(errorMessage.message || 'Error during verify-opt');
  }
};

//  function to submit data
export const captchaVerification = async (captchaData) => {
  try {
    const response = await axios.post(
      "https://loginmodule.hyperthings.in/api/v1/submit",
      captchaData
    );

    // Check if the response data exists
    console.log("Submit Response:", response);

    // If there's no response or an error code, handle it
    if (!response || !response.data) {
      throw new Error("CAPTCHA verification response is empty or malformed.");
    }

    // Check the specific response code to verify CAPTCHA status
    if (response.data.code === 40) {
      throw new Error("CAPTCHA Failed. Please try again.");
    }

    // Return the valid response data
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data || { code: 500, message: 'Unknown error occurred' };
    console.error("Submit Error:", errorMessage);
    // Return a more detailed error response if the CAPTCHA fails
    throw new Error(errorMessage.message || 'Error during verify-opt');
  }
};


//  function to get captcha
export const getCaptcha = async () => {
  try {
    const response = await axios.get(
      "https://loginmodule.hyperthings.in/api/v1/captcha"
    );

    // Extract the x-captcha-id header
    const captchaId = response.headers["x-captcha-id"];

    return {
      captchaData: response.data,
      captchaId: captchaId,
    };
  } catch (error) {
    const errorMessage = error.response?.data || { code: 500, message: 'Unknown error occurred' };
    console.error("Captcha Error:", errorMessage);
    throw new Error(errorMessage.message || 'Error during verify-opt');
  }
};
